import ConcealablePanel from "./ConcealablePanel";

export default ConcealablePanel;
